
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class TipologieCaricamentiGrid extends Serenity.EntityGrid<TipologieCaricamentiRow, any> {
        protected getColumnsKey() { return TipologieCaricamentiColumns.columnsKey; }
        protected getDialogType() { return TipologieCaricamentiDialog; }
        protected getIdProperty() { return TipologieCaricamentiRow.idProperty; }
        protected getInsertPermission() { return TipologieCaricamentiRow.insertPermission; }
        protected getLocalTextPrefix() { return TipologieCaricamentiRow.localTextPrefix; }
        protected getService() { return TipologieCaricamentiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);
            return buttons;
        }
    }
}